import React from 'react';

interface AppHeaderTitleProps {
  title: string;
  description?: string;
}

const AppHeaderTitle: React.FC<AppHeaderTitleProps> = ({ title, description }) => {
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
      {description && <p className="text-sm text-gray-600 mt-1">{description}</p>}
    </div>
  );
};

export default AppHeaderTitle;
